import axios from 'axios'
import _ from 'lodash'

async function fetchCommonConfigurations() {
  return await axios.get('/conf/config.common.json')
}

async function fetchEnvConfigurations() {
  let env = process.env.NODE_ENV !== 'development' ? 'env' : 'local'
  return await axios.get(`/conf/config.${env}.json`)
}

/**
 * Creates vue plugin from app configuration
 * @param config
 * @returns {{install: install}}
 * @constructor
 */
export function AppConfigurationPlugin(config) {
  return {
    install: (Vue, options) => {
      Vue.prototype.$appConfig = config
    }
  }
}

/**
 * Gets app configuration
 * @returns {Promise<object>}
 */
export async function fetchAppConfiguration() {
  const common = await fetchCommonConfigurations()
  const env = await fetchEnvConfigurations()
  return _.merge(common.data, env.data)
}
